import { render, staticRenderFns } from "./FlightLoad.vue?vue&type=template&id=106043df&"
import script from "./FlightLoad.vue?vue&type=script&lang=js&"
export * from "./FlightLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports